import React, { useState, useEffect } from "react";
import Select from "react-select";
import { get } from "../../utils/api";

interface SelectModuleProps {
  mapped_collection: {
    collection: string;
    primary_id_field: string;
    primary_name_field: string;
  };
  value?: {
    [key: string]: any;
  };
  onChange: (option: any) => void;
}

function SelectModule({ mapped_collection, value, onChange }: SelectModuleProps) {
  const { collection, primary_id_field, primary_name_field } = mapped_collection;
  const [options, setOptions] = useState([]);
  const [selectedOption, setSelectedOption] = useState(
    value ? { value, label: value[primary_name_field] } : null
  );
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchFields = async () => {
    setLoading(true);
    setError(null); // Reset error state on new fetch attempt
    const params = { page: 1, limit: 1000, filter: {}, sortBy: {} };
    try {
      const response = await get(`${collection}`, params);
      const fieldOptions = response.data.data.map((item: any) => ({
        value: {
          [primary_id_field]: item[primary_id_field],
          [primary_name_field]: item[primary_name_field],
        },
        label: item[primary_name_field],
      }));
      setOptions(fieldOptions);
    } catch (error) {
      console.error("Failed to fetch fields:", error);
      setError("Failed to load options, click to retry");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFields();
  }, [collection, primary_id_field, primary_name_field]);

  // Effect to handle external value changes
  useEffect(() => {
    if (value) {
      setSelectedOption({ value, label: value[primary_name_field] });
    } else {
      setSelectedOption(null);  // Handle null or undefined value case
    }
  }, [value, primary_name_field]);

  const handleRetry = () => {
    setError(null);
    fetchFields();
  };

  if (loading) return <p>Loading...</p>;
  if (error)
    return (
      <div>
        <p>{error}</p>
        <button onClick={handleRetry} style={{ padding: "8px 16px", cursor: "pointer" }}>Retry</button>
      </div>
    );

  return (
    <Select
      className="basic-single"
      value={selectedOption}
      onChange={(selected) => {
        setSelectedOption(selected);
        onChange(selected?.value || null);
      }}
      options={options}
      classNamePrefix="select"
      isClearable={true}
      isSearchable={true}
    />
  );
}

export default SelectModule;
